import React from 'react';
import { Typography } from '@lucid/lego';
import { useStore } from '../../../store/store';

const SavedCases: React.FC = () => {
  const theme = useStore((state) => state.theme);
  return (
    <>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Saved Cases
      </Typography>
    </>
  );
};

export default SavedCases;
